import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Img2 from './image/4498685.png';

const ErrorPage = () => {

    const css = `
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: "Consolas", monospace;
        }

        :root {
            --bgcolor-dark: #1b1818;
            --text-clr-dark: #371d5f;
            --icon-clr: #18d1d1;
            --bgcolor-light: #f3eaea;
            --text-clr-light: #111;
            --icon-clr-light: #0099ff;
        }

        .error-header {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: linear-gradient(to right, #2e7fc2 0%, #6acad2 100%);
        }

        .container {
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        .card1 {
            width: 100%;
            padding: 20px;
            background: rgba(255, 255, 255, 0.27);
            border-radius: 16px;
            box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
            backdrop-filter: blur(1.5px);
            -webkit-backdrop-filter: blur(1.5px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            text-align: center;
        }

        .text-container img {
            width: 60px;
            height: auto;
            margin-bottom: 20px;
        }

        .text-container h2, .text-container h3 {
            font-weight: 1000;
            margin-bottom: 10px;
        }

        .text-container h2 {
            font-size: 60px;
        }

        .text-container span {
            color: #bd1313;
        }

        .btn-container {
            margin-top: 20px;
        }

        .btn {
            color: var(--bgcolor-dark);
            padding: 10px;
            border: none;
            background: var(--icon-clr);
            border-radius: 10px;
            font-weight: 530;
            font-size: 15px;
            cursor: pointer;
            background: linear-gradient(to right, #2e7fc2 0%, #6acad2 100%);
            color: #fff;
            border: 1px solid #fff;
        }

        .btn:hover {
            opacity: 0.7;
        }

        .btn:active {
            opacity: 0.5;
        }

        @media only screen and (max-width: 800px) {
            .text-container h2 {
                font-size: 50px;
            }
        }

        @media only screen and (prefers-color-scheme: light) {
            :root {
                --bgcolor-dark: #f3eaea;
                --text-clr-dark: #4d1f1c;
                --icon-clr: #0099ff;
            }
        }
    `;

    return (
        <header className="error-header">
              <img src={Img2}  alt="Error Icon"  style={{ width: '500px' }} />
            <div className="container">
          
                <div className="text-container">
                   
                    <div className="card1">
                       
                        <h3>
                            <span>This page is currently</span> <span>under maintenance.</span> 
                        </h3>
                        <div className="btn-container">
                            <Link to="/Home" style={{ textDecoration: 'none' }}>
                                <Button 
                                    className="btn"
                                    fullWidth 
                                    variant="contained"
                                >
                                    <b>Go to Home</b>
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {css}
            </style>
        </header>
    );
};

export default ErrorPage;
